import { render, staticRenderFns } from "./app-ado.vue?vue&type=template&id=515ea0d0&scoped=true&"
import script from "./app-ado.vue?vue&type=script&lang=ts&"
export * from "./app-ado.vue?vue&type=script&lang=ts&"
import style0 from "./app-ado.vue?vue&type=style&index=0&id=515ea0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ea0d0",
  null
  
)

export default component.exports